// extracted by mini-css-extract-plugin
export default {"container":"AdminForm_container__NDnYR","title":"AdminForm_title__fnzlC","removeButton":"AdminForm_removeButton__F5x66","actions":"AdminForm_actions__bs16K"};